import { render, staticRenderFns } from "./BgGray.vue?vue&type=template&id=82c55956&scoped=true"
import script from "./BgGray.vue?vue&type=script&lang=js"
export * from "./BgGray.vue?vue&type=script&lang=js"
import style0 from "./BgGray.vue?vue&type=style&index=0&id=82c55956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c55956",
  null
  
)

export default component.exports